export const travel = {
  components: [
    {
      type: 'product-summary',
      settings: {
        heading: 'Finalise your Travel quote',
        content: `
          You'll need to confirm the answers you've previously given and answer any extra questions so we know the details that we're using are correct
        `,
        buttons: [
          {
            link: '',
            label: 'Continue quote'
          }
        ],
        card: {
          heading: 'Your trip details',
          mapping: 'travel_destination',
          icon: 'huddle-filled-marketing-visitorcontentsemergencies',
          content: [
            {
              heading: 'Departing on',
              mapping: 'trip_start_date'
            },
            {
              heading: 'Returning home on',
              mapping: 'trip_end_date'
            },
            {
              heading: 'Cover level',
              mapping: 'cover_level'
            }
          ]
        },
        callout: {
          heading: 'cover',
          mapping: 'cover_level',
          subtext: `Including GST and Gov't charges (as applicable), and {{ arrang_fee }} Policy Arrangement Fee*`, 
        }
      }
    },
    {
      type: 'product-trustpilot',
      settings: {
        heading: 'Join 100k+ Australians with Huddle Insurance'
      }
    },
    {
      type: 'product-cross-content',
      settings: {
        heading: 'Airport lounge access with Smart Flight Delay',
        content: `Don't let flight delays ruin your trip. Smart Flight Delay is included with our International Black Comprehensive plan, and gives you access to 1,400+ lounges around the world in just 2 steps:
        <ol>
          <li><strong>Register your flights</strong><br>You need to <a href="https://huddle.smartdelay.com/" color="primary">register</a> your flights at least 2 hours before your flight\'s scheduled departure time. You can register all of the flights on your international trip.<br><br></li>
          <li><strong>We'll monitor your flights</strong><br>If your flight is delayed for more than 60 minutes from its originally scheduled departure time, you\'ll receive an email with a complimentary voucher for you and up to four guests flying with you.<sup>1</sup></li>
        </ol>`,
        image: 'https://media.beopen.com/huddle/huddle-travel-lounge-acces.webp',
        buttons: [
          {
            link: '',
            label: 'Continue quote'
          }
        ],
        disclaimer: '<a href="https://huddle.com.au/pds" color="primary" class="small">Terms and conditions apply</a>'
      }
    },
    {
      type: 'product-card',
      layout: 'icon',
      settings: {
        theme: 'light',
        columns: 4,
        type: 'simple-icon',
        heading: 'Travel with confidence',
        cards: [
          {
            image: 'huddle-outlined-marketing-optionals',
            title: 'Build the cover that suits you',
            content: 'Choose your level of cover, pick your cover limit for your cancellation expenses or purchase Optional Extras. It’s how travel insurance should be.'
          },
          {
            image: 'huddle-outlined-management-emergencyassistance',
            title: '24/7 Emergency Assistance',
            content: 'You\'ll have direct access to our 24/7 Emergency Assistance team if you need help while travelling.'
          },
          {
            image: 'huddle-outlined-valuables-personalmedicalequipment',
            title: 'COVID-19 cover if you’re sick overseas',
            content: 'All of our international plans include cover for overseas emergency medical costs if you\'re diagnosed with COVID-19 on your trip. Cover terms apply.'
          }
        ]
      }
    },
    {
      type: 'product-features-table',
      settings: {
        heading: 'Fly away with cover that suits you',
        subtext: 'Summary only. Full benefits, terms and conditions are in our <a href="https://huddle.com.au/pds" color="primary" target="_blank">Product Disclosure Statement</a>.',
        tableData: [
          {
            tabLabel: 'International',
            footer: `
              <p>2. The cover limit for Cancellation expenses is chosen when you buy your policy and will be listed on your Certificate of Insurance. This limit is the maximum we’ll pay for all claims for this benefit under your policy. The limit is not per adult traveller. Sub-limits apply.</p>
              <p>3. Sub-limits apply.</p>
              <p>4. The term ‘Unlimited’ means that for covered events, there is no capped dollar sum insured. Terms, conditions, exclusions limits and sub-limits apply. Please refer to the Product Disclosure Statement for further details.</p>
              <p>5. There’s no cover under Personal liability and Permanent disability for any claims arising from participation in any of the activities listed under the Adventure Pack, the Motorcycle/Moped Pack or the Snow Pack.</p>
            `,
            table: [
              [
                {},
                {
                  label: 'Essentials'
                },
                {
                  label: 'Standard'
                },
                {
                  label: 'Black Comprehensive'
                }
              ],
              [
                {
                  label: 'Your health'
                },
                {},
                {},
                {}
              ],
              [
                {
                  label: 'Overseas emergency medical and repatriation'
                },
                {
                  label: 'Unlimited<sup>4</sup>',
                  icon: 'check_circle_outline'
                },
                {
                  label: 'Unlimited<sup>4</sup>',
                  icon: 'check_circle',
                  colour: '#0B793D'
                },
                {
                  label: 'Unlimited<sup>4</sup>',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: 'Hospital cash allowance'
                },
                {
                  label: 'No cover',
                  icon: 'clear'
                },
                {
                  label: 'No cover',
                  icon: 'clear'
                },
                {
                  label: '$5,000<sup>3</sup>',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: 'Accidental death'
                },
                {
                  label: 'No cover',
                  icon: 'clear'
                },
                {
                  label: 'No cover',
                  icon: 'clear'
                },
                {
                  label: '$25,000<sup>3</sup>',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: 'Permanent disability<sup>5</sup>'
                },
                {
                  label: 'No cover',
                  icon: 'clear'
                },
                {
                  label: 'No cover',
                  icon: 'clear'
                },
                {
                  label: '$25,000<sup>3</sup>',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: 'Loss of income'
                },
                {
                  label: 'No cover',
                  icon: 'clear'
                },
                {
                  label: 'No cover',
                  icon: 'clear'
                },
                {
                  label: '$10,400<sup>3</sup>',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: 'Your trip'
                },
                {
                },
                {
                },
                {
                }
              ],
              [
                {
                  label: 'Cancellation expenses'
                },
                {
                  label: 'As selected<sup>9</sup>'
                },
                {
                  label: 'As selected<sup>9</sup>'
                },
                {
                  label: 'As selected<sup>9</sup>'
                }
              ],
              [
                {
                  label: 'Additional expenses'
                },
                {
                  label: '$5,000<sup>3</sup>',
                  icon: 'check_circle_outline'
                },
                {
                  label: '$25,000<sup>3</sup>',
                  icon: 'check_circle',
                  colour: '#0B793D'
                },
                {
                  label: '$50,000<sup>3</sup>',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: 'Travel delay expenses'
                },
                {
                  label: 'No cover',
                  icon: 'clear'
                },
                {
                  label: 'No cover',
                  icon: 'clear'
                },
                {
                  label: '$2,000<sup>3</sup>',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: 'Special event transport expenses'
                },
                {
                  label: 'No cover',
                  icon: 'clear'
                },
                {
                  label: 'No cover',
                  icon: 'clear'
                },
                {
                  label: '$5,000',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: 'Your stuff'
                },
                {
                },
                {
                },
                {
                }
              ],
              [
                {
                  label: 'Luggage and personal belongings'
                },
                {
                  label: '$2,500<sup>3</sup>',
                  icon: 'check_circle_outline'
                },
                {
                  label: '$5,000<sup>3</sup>',
                  icon: 'check_circle',
                  colour: '#0B793D'
                },
                {
                  label: '$10,000<sup>3</sup>',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: '<span class="font-normal">SUB-LIMITS</span>'
                },
                {
                },
                {
                },
                {
                }
              ],
              [
                {
                  label: '<span class="font-normal">Personal computers, laptops, tablets, cameras or video cameras</span>'
                },
                {
                  label: '$1,000',
                  icon: ''
                },
                {
                  label: '$3,000',
                  icon: ''
                },
                {
                  label: '$3,000',
                  icon: ''
                }
              ],
              [
                {
                  label: '<span class="font-normal">Mobile phones, smartphones and smartwatches</span>'
                },
                {
                  label: '$750',
                  icon: ''
                },
                {
                  label: '$1,000',
                  icon: ''
                },
                {
                  label: '$1,000',
                  icon: ''
                }
              ],
              [
                {
                  label: '<span class="font-normal">All other items</span>'
                },
                {
                  label: '$500',
                  icon: ''
                },
                {
                  label: '$750',
                  icon: ''
                },
                {
                  label: '$750',
                  icon: ''
                }
              ],
              [
                {
                  label: 'Your liability'
                },
                {
                },
                {
                },
                {
                }
              ],
              [
                {
                  label: 'Rental vehicle insurance excess'
                },
                {
                  label: 'No cover',
                  icon: 'clear'
                },
                {
                  label: '$3,000',
                  icon: 'check_circle',
                  colour: '#0B793D'
                },
                {
                  label: '$6,000',
                  icon: 'check_circle'
                }
              ],
              [
                {
                  label: 'Personal liability<sup>5</sup>'
                },
                {
                  label: '$1,000,000',
                  icon: 'check_circle_outline'
                },
                {
                  label: '$2,500,000',
                  icon: 'check_circle',
                  colour: '#0B793D'
                },
                {
                  label: '$5,000,000',
                  icon: 'check_circle'
                }
              ]
            ]
          },

          {
            tabLabel: 'Domestic',
            footer: `
              <p>6. The cover limit for Cancellation expenses is chosen when you buy your policy and will be listed on your Certificate of Insurance. This limit is the maximum we\'ll pay for all claims for this benefit under your policy. The limit is not per adult traveller. Sub-limits apply.</p>
              <p>7. Sub-limits apply.</p>
              <p>8. There’s no cover under Personal liability and Permanent disability for any claims arising from the Snow Pack.</p>
            `,
            table: [
              [
                {},
                {
                  label: 'Black Comprehensive'
                },
                {
                  label: ''
                },
                {
                  label: ''
                }
              ],
              [
                {
                  label: 'Your Trip'
                },
                {
                },
                {
                },
                {
                }
              ],
              [
                {
                  label: 'Cancellation expenses'
                },
                {
                  label: 'As selected<sup>9</sup>'
                },
                {
                  label: '',
                  icon: ''
                },
                {
                  label: '',
                  icon: ''
                }
              ],
              [
                {
                  label: 'Additional expenses'
                },
                {
                  label: '$50,000<sup>7</sup>',
                  icon: 'check_circle'
                },
                {
                  label: '',
                  icon: ''
                },
                {
                  label: '',
                  icon: ''
                }
              ],
              [
                {
                  label: 'Travel delay expenses'
                },
                {
                  label: '$2,000<sup>7</sup>',
                  icon: 'check_circle'
                },
                {
                  label: '',
                  icon: ''
                },
                {
                  label: '',
                  icon: ''
                }
              ],
              [
                {
                  label: 'Your stuff'
                },
                {
                  label: '',
                  icon: ''
                },
                {
                  label: '',
                  icon: ''
                },
                {
                  label: '',
                  icon: ''
                }
              ],
              [
                {
                  label: 'Luggage and personal belongings'
                },
                {
                  label: '$10,000<sup>7</sup>',
                  icon: 'check_circle'
                },
                {
                  label: '',
                  icon: ''
                },
                {
                  label: '',
                  icon: ''
                }
              ],
              [
                {
                  label: '<span class="font-normal">SUB-LIMITS</span>'
                },
                {
                },
                {
                },
                {
                }
              ],
              [
                {
                  label: '<span class="font-normal">Personal computers, laptops, tablets, cameras or video cameras</span>'
                },
                {
                  label: '$3,000',
                  icon: ''
                },
                {
                },
                {
                }
              ],
              [
                {
                  label: '<span class="font-normal">Mobile phones, smartphones and smartwatches</span>'
                },
                {
                  label: '$1,000',
                  icon: ''
                },
                {
                },
                {
                }
              ],
              [
                {
                  label: '<span class="font-normal">All other items</span>'
                },
                {
                  label: '$750',
                  icon: ''
                },
                {
                },
                {
                }
              ],
              [
                {
                  label: 'Delayed luggage and personal belongings'
                },
                {
                  label: '$750',
                  icon: 'check_circle'
                },
                {
                },
                {
                }
              ],
              [
                {
                  label: 'Your health'
                },
                {
                },
                {
                },
                {
                }
              ],
              [
                {
                  label: 'Accidental death'
                },
                {
                  label: '$25,000<sup>7</sup>',
                  icon: 'check_circle'
                },
                {
                },
                {
                }
              ],
              [
                {
                  label: 'Permanent disability<sup>8</sup>'
                },
                {
                  label: '$25,000<sup>7</sup>',
                  icon: 'check_circle'
                },
                {
                },
                {
                }
              ],
              [
                {
                  label: 'Your liability'
                },
                {
                },
                {
                },
                {
                }
              ],
              [
                {
                  label: 'Rental vehicle insurance excess'
                },
                {
                  label: '$6,000',
                  icon: 'check_circle'
                },
                {
                },
                {
                }
              ],
              [
                {
                  label: 'Personal liability<sup>8</sup>'
                },
                {
                  label: '$5,000,000',
                  icon: 'check_circle'
                },
                {
                },
                {
                }
              ]
            ]
          }
        ]
      }
    },
    {
      type: 'product-card',
      layout: 'icon',
      settings: {
        theme: 'light',
        columns: 4,
        type: 'simple-icon',
        heading: 'Optional Extras',
        subtext: 'Build the cover that suits your trip, with our range of Optional Extras. <br>Summary only. Full benefits, terms and conditions are in our <a href="https://huddle.com.au/pds" target="_blank" color="primary">Product Disclosure Statement</a>.',
        cards: [
          {
            image: 'huddle-outlined-travel-cruise',
            title: 'Cruise Pack',
            content: 'Cover for your overnight or multi-night sea or ocean cruise, plus access to extra cruise-related benefits like ship to shore evacuation and cabin confinement.',
            capsules: [
              {
                label: 'Black Comprehensive',
                theme: 'black'
              }
            ]
          },
          {
            image: 'huddle-outlined-options-sportcover',
            title: 'Snow Pack',
            content: 'Cover for your snow sport activities, plus access to extra snow-related benefits like cover for your own snow sport equipment and piste closure. An additional excess applies.',
            capsules: [
              {
                label: 'Standard',
                theme: '#004F3D'
              },
              {
                label: 'Black Comprehensive',
                theme: 'black'
              }
            ]
          },
          {
            image: 'huddle-outlined-values-noexcuses',
            title: 'Adventure Pack',
            content: 'Cover for activities like abseiling, zip-lining, outdoor rock climbing (with ropes and safety gear) and more.Not available with our Domestic plan.',
            capsules: [
              {
                label: 'Standard',
                theme: '#004F3D'
              },
              {
                label: 'Black Comprehensive',
                theme: 'black'
              }
            ]
          },
          {
            image: 'huddle-outlined-travel-motorcyclecover',
            title: 'Motorcycle/Moped Pack',
            content: 'Cover for riding a motorcycle or moped overseas (as a rider or passenger) on your trip.Not available with our Domestic plan.',
            capsules: [
              {
                label: 'Standard',
                theme: '#004F3D'
              },
              {
                label: 'Black Comprehensive',
                theme: 'black'
              }
            ]
          },
          {
            image: 'huddle-valuables-electronics',
            title: 'Valuables Pack',
            content: 'Travelling with valuables? You can increase the sub-limits under your plan for your luggage and personal belongings for extra protection.',
            capsules: [
              {
                label: 'Black Comprehensive',
                theme: 'black'
              }
            ]
          }
        ]
      }
    },
    {
      type: 'product-accordion',
      settings: {
        heading: 'Commonly asked questions',
        accordionItems: [
          {
            title: 'Can I purchase a Huddle travel insurance policy if I\'m already travelling?',
            content: `
            No, you won't be eligible to purchase a Huddle travel insurance policy if you're already travelling. You need to purchase a Huddle travel insurance policy before you begin your trip.<br><br>
            Cover terms apply. Please refer to the relevant PDS for more details.
            `
          },
          {
            title: 'How do I make changes to my travel insurance policy?',
            content: `
            Need to extend your trip or add a destination to your policy?<br><br> 
            You can apply to make changes to your policy by logging in to your <a href="" color="primary">Huddle account</a>.<br><br>
            Cover terms apply. Please refer to the relevant PDS for more details.
            `
          },
          {
            title: 'Does this travel insurance policy cover pre-existing medical conditions?',
            content: `
            We cover the 31 pre-existing medical conditions listed in the table below, as long as you meet the following criteria on the date you purchase your policy:<br>
            <ul> 
              <li>you haven't been hospitalised or needed treatment for any of the listed conditions by any medical adviser in the last 12 months (unless a different time period is listed in below);</li>
              <li>you aren't under investigation for any of the listed conditions;</li>
              <li>you aren't awaiting investigation, surgery, treatment or procedures for any of the listed medical conditions; and</li>
              <li>your condition meets any relevant additional criteria listed in the table below.</li>
            </ul>
            The specified additional criteria (if any) apply, including any stated time periods related to these covered medical conditions listed in the table below, at the time your policy is purchased.<br><br>
            <div class="grid margin-bottom-xmedium">
              <div class="cell cell-large-col-span-4 font-bold">Medical condition</div>
              <div class="cell cell-large-col-span-5 font-bold">Additional criteria</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Acne</div>
              <div class="cell cell-large-col-span-5">No additional criteria.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Allergy</div>
              <div class="cell cell-large-col-span-5">
                <ul>
                  <li>You have no known respiratory conditions e.g. asthma; and</li>
                  <li>You haven’t required treatment by a medical adviser in the last 6 months.</li>
                </ul>
              </div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Asthma</div>
              <div class="cell cell-large-col-span-5">
                <ul>
                  <li>You’re under 60 years of age at the time your policy is issued; and</li>
                  <li>You have no other lung disease.</li>
                </ul>
              </div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Bell’s palsy</div>
              <div class="cell cell-large-col-span-5">No additional criteria.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Bunions</div>
              <div class="cell cell-large-col-span-5">No additional criteria.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Carpal tunnel syndrome</div>
              <div class="cell cell-large-col-span-5">No additional criteria.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Cataracts</div>
              <div class="cell cell-large-col-span-5">In the last 90 days, you haven’t had an operation for this condition.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Coeliac disease</div>
              <div class="cell cell-large-col-span-5">In the last 6 months, you haven’t been treated by a medical adviser for this condition.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Congenital blindness</div>
              <div class="cell cell-large-col-span-5">No additional criteria.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Congenital deafness</div>
              <div class="cell cell-large-col-span-5">No additional criteria.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Ear grommets</div>
              <div class="cell cell-large-col-span-5">You haven’t had an ear infection in the last 3 months.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Epilepsy</div>
              <div class="cell cell-large-col-span-5">
                <ul>
                  <li>You haven't required hospitalisation for epilepsy in the last 2 years, including as an outpatient;</li>
                  <li>You haven’t changed your medication regime for epilepsy in the last 12 months; and</li>
                  <li>You don't have an underlying medical condition that causes, contributes to or materially increases the risk of the epilepsy e.g. previous head trauma, brain tumour or stroke.</li>
                </ul>
              </div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Gastric reflux</div>
              <div class="cell cell-large-col-span-5">Your gastric reflux doesn’t relate to an underlying diagnosis e.g. hernia or gastric ulcer.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Glaucoma</div>
              <div class="cell cell-large-col-span-5">You have no ongoing complications for this condition.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Goitre</div>
              <div class="cell cell-large-col-span-5">No additional criteria.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Gout</div>
              <div class="cell cell-large-col-span-5">No additional criteria.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Graves’ disease</div>
              <div class="cell cell-large-col-span-5">No additional criteria.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Hiatus hernia</div>
              <div class="cell cell-large-col-span-5">No additional criteria.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Hip replacement, knee replacement and shoulder replacement</div>
              <div class="cell cell-large-col-span-5">The procedure was performed more than 6 months ago and less than 10 years ago.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Hip resurfacing</div>
              <div class="cell cell-large-col-span-5">You haven’t had any postoperative complications relating to the surgery.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Hypercholesterolaemia (high cholesterol)</div>
              <div class="cell cell-large-col-span-5">You don’t have a known heart or cardiovascular condition.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Hypertension (high blood pressure)</div>
              <div class="cell cell-large-col-span-5">
                <ul>
                  <li>You don’t have a known heart or cardiovascular condition;</li>
                  <li>You don’t have Type 1 diabetes or Type 2 diabetes;</li>
                  <li>In the last 12 months your blood pressure medication hasn’t changed; and</li>
                  <li>You aren’t suffering symptoms of hypertension.</li>
                </ul>
              </div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Menopause</div>
              <div class="cell cell-large-col-span-5">You don’t have osteoporosis.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Peptic ulcer/gastric ulcer</div>
              <div class="cell cell-large-col-span-5">In the last 12 months, the peptic/gastric ulcer has been stable.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Plantar fasciitis</div>
              <div class="cell cell-large-col-span-5">No additional criteria.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Raynaud’s disease</div>
              <div class="cell cell-large-col-span-5">No additional criteria.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Skin cancer</div>
              <div class="cell cell-large-col-span-5">
                <ul>
                  <li>Your skin cancer isn’t a melanoma;</li>
                  <li>You haven’t had chemotherapy or radiotherapy for this condition; and</li>
                  <li>Your skin cancer doesn’t require any follow-up treatment.</li>
                </ul>
              </div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Trigger finger</div>
              <div class="cell cell-large-col-span-5">No additional criteria.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Urinary incontinence</div>
              <div class="cell cell-large-col-span-5">No additional criteria.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
              <div class="cell cell-large-col-span-4 font-bold">Underactive thyroid/ overactive thyroid</div>
              <div class="cell cell-large-col-span-5">The cause of your underactive/overactive thyroid wasn’t a tumour.</div>
              <div class="cell cell-large-col-span-12 expansion-panel-table-divider"></div>
            </div>
            If you have a pre-existing medical condition when you purchase your policy that:
            <ul>
              <li>isn't listed in the table above; or</li>
              <li>is listed in the table above, but at the date you purchase the policy, you don't meet the relevant criteria for it to be covered,</li>
            </ul>
            then you won't be covered for any claim that arises from the pre-existing medical condition. <br>
            Terms, conditions, exclusions, limits and sub-limits apply. Please see the relevant PDS for more details.
            `
          },
          {
            title: 'Am I covered if I ride a motorcycle or moped overseas?',
            content: `
              If you're planning on riding a motorcycle or moped overseas on your trip and want cover for participating in those activities, you'll need to purchase the optional Motorcycle/Moped Pack, available on International Black Comprehensive and Standard Plans only.<br><br>
              Adding the Motorcycle/Moped Pack doesn't add another policy benefit, but it extends cover under your policy to include claims that arise because of participating in riding a motorcycle or moped overseas on your trip, except for cover under Permanent disability and Personal liability.<br><br>
              Cover is provided under this Optional Extra pack only if:
              <ul>
                <li>the motorcycle or moped is motorised and its engine capacity is 250cc or less;</li>
                <li>while in control of the motorcycle or moped, you hold an Australian motorcycle rider’s licence or an Australian motor vehicle driver’s licence valid for that class of motorcycle or moped being ridden, and a licence valid for the country that the motorcycle or moped is being ridden in;</li>
                <li>while you're a passenger, the driver in control of the motorcycle or moped holds a license valid for the country that the motorcycle or moped is being ridden in;</li>
                <li>you're wearing an appropriate safety helmet;</li>
                <li>you're not racing the motorcycle or moped; and</li>
                <li>you're not riding the motorcycle or moped in a professional capacity (for example, as a paid delivery driver).</li>
              </ul>
              If you're participating in riding a motorcycle or moped overseas on your trip and you haven't bought the Motorcyle/Moped Pack, there'll be no cover under the policy for any claims related to this activity.<br><br>
              Terms, conditions, exclusions, limits and sub-limits apply. Please refer to the relevant PDS for more details.
            `
          },
          {
            title: 'Does this travel insurance policy cover cruising?',
            content: `
              Going on a river cruise? Cover for river cruises are automatically included under your policy.<br><br>
              However, if you're planning on heading on an overnight or multi-night sea or ocean cruise within Australian territorial waters or while you are overseas, you'll need to purchase the optional Cruise Pack. The optional Cruise Pack is only available on International Black Comprehensive and Black Domestic Comprehensive plans.<br><br>
              Buying the Cruise Pack extends the cover under this policy’s benefits for claims arising from your cruise and adds some additional cruise-related benefits such as cover for Emergency medical cover while cruising including ship to shore evacuation cover, Cabin confinement and Missed shore excursions.<br><br>
              If you're going on an overnight or multi-night sea or ocean cruise while you're on your trip and you haven't bought the Cruise Pack, there'll be no cover under the policy for claims related to that cruise.<br><br>
              Terms, conditions, exclusions, limits and sub-limits apply. Please refer to the relevant PDS for more details.
            `
          },
          {
            title: 'Does this travel insurance policy cover claims related to COVID-19?',
            content: `
            If you or your travel companion are positively diagnosed as suffering a sickness recognised as an epidemic or pandemic (like COVID-19), and the diagnosis is certified by a medical adviser in writing, you may be able to claim for some benefits which are specified in the PDS. This includes the cancellation or rescheduling of your trip, or your medical expenses incurred overseas during your trip, due to this diagnosis. <br><br>
            Except for this limited cover, cover for epidemics and pandemics are generally excluded under the policy.<br><br>
            This means you will not be covered if you contracted the epidemic or pandemic sickness when you had travelled against an advice or warning by the Australian Government and didn't take appropriate action to avoid contracting the sickness, for example, by delaying travel to the country or part of the country referred to in the travel warning.<br><br>
            Terms, conditions, exclusions, limits and sub-limits apply. Please refer to the relevant PDS for more details.
            `
          }
        ]
      }
    }
  ]
}